module.exports = __webpack_public_path__ + "img/content5_1008_15.0fc756ff.png";